import { gql } from '@apollo/client';

export const SYNCHRONIZE_OAAD_LDAP = gql`
    mutation SynchronizeOaadLdap {
        synchronizeOaadLdap {
            deactivatedCount
            activatedCount
            updatedCount
        }
    }
`;

export const AMQP = gql`
    query Amqp {
        amqp {
            lastRequestTime
            virtualHosts {
                virtualHost
                connectionStatus
                nodeHostname
            }
        }
    }
`;

export const REDECLARE_AMQP_EXCHANGES = gql`
    mutation RedeclareAmqpExchanges {
        redeclareAmqpExchanges {
            redeclaredCount
        }
    }
`;

export const ALL_REQUEST_RATE_LIMITS_QUERY_NAME = 'AllRequestRateLimits';
export const ALL_REQUEST_RATE_LIMITS = gql`
    query ${ALL_REQUEST_RATE_LIMITS_QUERY_NAME} {
        allRequestRateLimits {
            availableUsers {
                racf
                name
            }
            availableRequestTypes
            period
            defaultRateLimit
            requestRateLimits {
                limitId
                requestType
                user {
                    racf
                    name
                }
                value
                messageRate
            }
        }
    }
`;

export const UPDATE_REQUEST_RATE_LIMITS = gql`
    mutation UpdateRequestRateLimits(
        $requestRateLimits: [RequestRateLimitInputInput],
    ) {
        updateRequestRateLimits(
            requestRateLimits: $requestRateLimits,
        ) {
            updatedCount
            deletedCount
            createdCount
        }
    }
`;

export const ALL_CLIENT_APPLICATIONS_QUERY_NAME = 'AllClientApplications';
export const ALL_CLIENT_APPLICATIONS = gql`
    query ${ALL_CLIENT_APPLICATIONS_QUERY_NAME} {
        allClientApplications {
            id
            applicationId
            description
            active
        }
    }
`;

export const UPDATE_CLIENT_APPLICATIONS = gql`
    mutation UpdateClientApplications(
        $clientApplications: [ClientApplicationInputInput],
    ) {
        updateClientApplications(
            clientApplications: $clientApplications,
        ) {
            updatedCount
            deletedCount
            createdCount
        }
    }
`;

export const FAILOVER = gql`
    query Failover {
        failover {
            nodeId
            ldapNode
        }
    }
`;

export const SWITCH_APPLICATION_NODE = gql`
    mutation SwitchApplicationNode {
        switchApplicationNode {
            nodeId
        }
    }
`;
